module.exports = __webpack_public_path__ + "img/dad_01.4abdc9ad.svg";